import { render, staticRenderFns } from "./tabGeneral.vue?vue&type=template&id=a067029a&"
import script from "./tabGeneral.vue?vue&type=script&lang=js&"
export * from "./tabGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports